import type { QuestionnaireWithResponse } from '@seen/core/models/questionnaireResponse'
import { createContext, useContext } from 'react'

// Supplies the care-plan demographic questionnaires + responses to Description
// questionnaire nodes so they resolve without baking a resource id into the
// stored HTML. The active care-plan page provides live (editable) responses;
// the signed-snapshot page provides the version-pinned responses the snapshot
// froze at sign time — same node, different source, so signed plans stay
// immutable.
const CarePlanDemographicsContext = createContext<
  QuestionnaireWithResponse[] | null
>(null)

export const CarePlanDemographicsProvider = CarePlanDemographicsContext.Provider

// Null when there is no surrounding provider (e.g. the description rendered
// outside a care-plan page) or the URL is not one of the care-plan demographics.
export function useCarePlanDemographicByUrl(
  url: string | null
): QuestionnaireWithResponse | null {
  const demographics = useContext(CarePlanDemographicsContext)
  if (!demographics || !url) {
    return null
  }
  return (
    demographics.find(({ questionnaire }) => questionnaire.url === url) ?? null
  )
}
